import Vue from 'vue';
import Vuex from 'vuex';

// MODULES
import rawData from './modules/raw-data';

import counter from './modules/counter';
import infoBoxCounter from './modules/info-box-counter';
import dataLayer from './modules/data-layer';
import filter from './modules/filter';
import google from './modules/google';
import list from './modules/list';
import markers from './modules/markers';
import provinces from './modules/provinces';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    rawData,
    counter,
    infoBoxCounter,
    filter,
    google,
    dataLayer,
    list,
    markers,
    provinces,
  },
});
